import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectExaminationSessionAnswersVM,
  selectParamExaminationSessionsLoaded,
} from './examination-session.selectors';
import { ExaminationSessionAnswersVM } from '@lyceo/lyceo-pupil-app/practise/util-models';

@Injectable({
  providedIn: 'root',
})
export class ExaminationSessionFacade {
  private readonly store: Store = inject(Store);

  public readonly paramExaminationSessionsLoaded: Signal<boolean> =
    this.store.selectSignal(selectParamExaminationSessionsLoaded);
  public readonly examinationSessionAnswersVM: Signal<ExaminationSessionAnswersVM> =
    this.store.selectSignal(selectExaminationSessionAnswersVM);
}
